import CapegoIntegrationSettings from "./CapegoIntegrationSettings.js";
import Model from "../Model.js";

/**
 * AgencyIntegrationSettings which includes all different settings for all different integrations (i.e: Capego integration)
 *
 * @param {CapegoIntegrationSettings} capegoIntegrationSettings - Capego integration settings which consist of an import mode, and office code
 */
export default class AgencyIntegrationSettings extends Model {
	constructor({
		capegoIntegrationSettings = new CapegoIntegrationSettings(),
	} = {}) {
		super(...arguments);
		this._capegoIntegrationSettings = capegoIntegrationSettings;
	}

	getCapegoIntegrationSettings() {
		return this._capegoIntegrationSettings;
	}

	setCapegoIntegrationSettings(value) {
		this._capegoIntegrationSettings = value;
	}

	_serializedProperties() {
		return {
			capegoIntegrationSettings:
				this._capegoIntegrationSettings._serializedProperties(),
		};
	}

	static transformMaterializationData(data) {
		data.capegoIntegrationSettings = CapegoIntegrationSettings.materialize(
			data.capegoIntegrationSettings,
		);
	}
}
